import Spinner from './customer/default/spinner.component';

export default Spinner;
